<!--
* @Name：议价审批物料信息明细详情
* @Author: 刘玉
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <van-dialog
    class="price-dialog"
    :value="detailsVisible"
    title="阶梯价格设定"
    show-cancel-button
    cancel-button-text="关闭"
    cancel-button-color="#1989fa"
    :show-confirm-button="false"
    @cancel="close"
  >
    <div class="details-container">
      <hi-card v-for="(item, index) in priceList" :key="item.tieredDetailId" :row-index="index + 1">
        <van-row>
          <span>阶梯：</span>
          <span>{{ item.level }}</span>
        </van-row>
        <van-row>
          <span>大于等于数量：</span>
          <span>{{ item.rangeStart }}</span>
        </van-row>
        <van-row>
          <span>小于等于数量：</span>
          <span>{{ item.rangeEnd }}</span>
        </van-row>
        <van-row>
          <span>价格：</span>
          <span>{{ item.price }}</span>
        </van-row>
      </hi-card>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'StagePriceInfo',
  data() {
    return {}
  },
  props: {
    priceList: {
      type: Array,
      default: () => []
    },
    detailsVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 500px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
}
</style>
